import * as universes from '@wecasa/common/src/ducks/common/universes';
import * as basket from '@wecasa/common/src/ducks/customer/basket';
import * as proAccounts from '@wecasa/common/src/ducks/customer/pro-accounts';

export default {
  universes,
  proAccounts,
  basket,
};
